import React, { ChangeEvent, useCallback, useEffect, useState } from 'react';
import { VbzInputText, Button } from '@smiles/voebiz-ui-kit';
import { isMobile } from 'react-device-detect';
import { Switch } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useDebounce } from '../../../hooks/useDebounce';
import { SyntheticEvent } from '../../../types/event.type';
import { PlanListType, GetCorporateClub } from '../../../services/types/type';
import { IMember, IPlan, useSelectedMembers } from '../../../contexts/SelectedMembers';
import ModalDefault, { IModal } from '../../Modal/ModalDefault';
import { FilterIcon } from '../../Icons/FilterIcon';
import ResponseModal from '../../ModalFilter';
import { SearchIcon } from '../../Icons/SearchIcon';
import ModalAddingBeneficiaries from '../../Modal/ModalAddingBeneficiaries';
import ModalRemovePlan from '../../Modal/ModalRemovePlan';
import useFilterData from '../../../hooks/useFilterData';
import { removeSelectedBeneficiariesPlans, updateBeneficiary } from '../../../services/service';
import { parseJwt } from '../../../utils/decodeJWT';
import { TableSearchProps, IValues } from './types/type';
import { formatSearch } from '../../../utils/formatSearch';
import { setTimerWithSavedTime } from '../../../utils/setTimerWithSavedTime';
import { TagFilter } from '../../TagFilter';
const getToken = parseJwt(`${localStorage.getItem('session-token')}`);

const memberNumVoeBiz = getToken?.sub.split('|')[2];

const defaultModalPropsDefaults = {
  imageClass: 'vbz-icon-corporates-club-baggage',
  component: 'defaultModalErrorInMass',
  isOpen: false,
  onClick: () => null,
  secondClick: () => null,
};

export const TableSearch = ({
  corporateClubList,
  plansEngagedCheckedNumber,
  plansAvailableEngagedCheckedNumber,
  allSelected,
  memberFiltered,
  setAllSelected,
  setEditionBlocked,
  editionBlocked,
}: TableSearchProps) => {
  const { t } = useTranslation('corporates-club');
  const [selectAllSwicthChecked, setSelectAllSwicthChecked] = useState(false);
  const [openFilterModal, setOpenFilterModal] = useState(false);
  const [openRemovePlanModal, setOpenRemovePlanModal] = useState(false);
  const [openModalBeneficiaries, setOpenModalBeneficiaries] = useState(false);
  const {
    allStatesCheck,
    allStatesCheckEngaged,
    setAllStatesCheckEngaged,
    allStatesAvailableCheckEngaged,
    setAllStatesAvailableCheckEngaged,
    filterButtonPressed,
    setVerifyExcludeAllPlans,
    setSelectedContractedPlan,
    setSelectedAvailablePlan,
    setSearch,
    setSelectedStartDate,
    setSelectedEndDate,
    setStartInclusionDate,
    selectedStartDate,
    selectedEndDate,
    setEndInclusionDate,
    setLoading,
  } = useFilterData();
  const [defaultModalProps, setDefaultModalProps] = useState<IModal>(defaultModalPropsDefaults);
  const { selectedMembers, clearMembers, addMember } = useSelectedMembers();
  const [fakeProfile, setFakeProfile] = useState({ planList: [] });
  const [value, setValue] = useState('');
  const debouncedValue = useDebounce<string>(value, 500);
  const plansEngagedChecked = Object.keys(allStatesCheckEngaged).filter((key) => allStatesCheckEngaged[key] === true);
  const plansEngagedAvailableChecked = Object.keys(allStatesAvailableCheckEngaged).filter(
    (key) => allStatesAvailableCheckEngaged[key] === true,
  );

  const checkSelectedPlanInModal = (): boolean => {
    if (filterButtonPressed) {
      const plansEngaged = Object.keys(allStatesCheckEngaged).some((key) => allStatesCheckEngaged[key] === true);
      const plansContracted = Object.keys(allStatesCheck).some((key) => allStatesCheck[key] === true);
      const plansAvailabelEngaged = Object.keys(allStatesCheckEngaged).some(
        (key) => allStatesAvailableCheckEngaged[key] === true,
      );
      const plansAvailable = Object.keys(allStatesCheck).some((key) => allStatesCheck[key] === true);
      if ((plansContracted || plansEngaged) && (plansAvailable || plansAvailabelEngaged)) {
        return true;
      }
    }
    return false;
  };

  const onToggleModal = useCallback((isOpen: boolean) => {
    setOpenFilterModal(isOpen);
  }, []);

  const onToggleRemovePlanModal = useCallback((isOpen: boolean) => {
    setOpenRemovePlanModal(isOpen);
  }, []);

  const handleEditProfile = () => {
    const allPlanList: any[] = [];
    selectedMembers.forEach((member: IMember) => {
      member.planList.forEach((plan: IPlan) => {
        if (!allPlanList.some((item: any) => item.miles === plan.miles)) {
          allPlanList.push({
            miles: plan.miles,
          });
        }
      });
    });
    setFakeProfile({
      planList: allPlanList as any,
    });
    setOpenModalBeneficiaries(true);
  };

  const closeModalBeneficiaries = () => {
    setOpenModalBeneficiaries(false);
  };

  const saveCurrentTime = () => {
    const currentTimeInMillis: number = Date.now();
    localStorage.setItem('block-timer', currentTimeInMillis.toString());
    console.log(`Current time (${currentTimeInMillis}) saved in localStorage.`);
    setTimeout(function () {
      setEditionBlocked(false);
      localStorage.removeItem('block-timer');
    }, 1800000);
  };

  const handleEditSuccesModalCTAClick = () => {
    if (allSelected) {
      setEditionBlocked(true);
      saveCurrentTime();
    }
    setDefaultModalProps((prevState) => ({ ...prevState, isOpen: false }));
    setAllSelected(false);
    setSelectAllSwicthChecked(false);
  };

  const removeSelectedBeneficiariesPlansHandler = async () => {
    // serviço de excluir benefícios
    let response;
    response = await removeSelectedBeneficiariesPlans(selectedMembers, allSelected);
    clearMembers();

    if (response) {
      if (response['Error Code'] === '00' && response['Error Message'] === 'Success') {
        setVerifyExcludeAllPlans(true);
        if (allSelected) {
          setDefaultModalProps(() => ({
            component: 'defaultModalSuccessInMassExclusionSelectAll',
            imageClass: 'vbz-icon-corporates-club-beach-chair',
            isOpen: true,
            onClick: () => setDefaultModalProps((prevState) => ({ ...prevState, isOpen: false })),
            secondClick: () => setDefaultModalProps((prevState) => ({ ...prevState, isOpen: false })),
          }));
        } else {
          setDefaultModalProps(() => ({
            component: 'defaultModalSuccessInMassExclusion',
            imageClass: 'vbz-icon-corporates-club-beach-chair',
            isOpen: true,
            onClick: () => setDefaultModalProps((prevState) => ({ ...prevState, isOpen: false })),
            secondClick: () => setDefaultModalProps((prevState) => ({ ...prevState, isOpen: false })),
          }));
        }

        setSelectedContractedPlan([]);
        setSelectedAvailablePlan([]);
      }
    } else {
      setDefaultModalProps(() => ({
        ...defaultModalPropsDefaults,
        isOpen: true,
        onClick: () => setDefaultModalProps((prevState) => ({ ...prevState, isOpen: false })),
        secondClick: () => setDefaultModalProps((prevState) => ({ ...prevState, isOpen: false })),
      }));
    }
  };

  const isFilterModalClosed = !openFilterModal;

  const isRemovePlanModalClosed = !openRemovePlanModal;
  useEffect(() => {
    document.body.classList.remove('unscrollable');
  }, [isFilterModalClosed, isRemovePlanModalClosed]);

  const editAllBeneficiaryHandler = async ({ values }: IValues) => {
    // serviço de editar beneficiários
    const miles = values.map((mile: string) => ({
      miles: mile,
    }));
    const payload: GetCorporateClub[] = selectedMembers.map((member: IMember) => {
      return {
        cpf: member.cpf,
        memberNumVoeBiz,
        planList: [...miles] as PlanListType[],
      };
    });
    const response = await updateBeneficiary(payload, allSelected);

    clearMembers();
    setOpenModalBeneficiaries(false);
    if (response) {
      if (response['Error Code'] === '00' && response['Error Message'] === 'Success') {
        if (allSelected) {
          setDefaultModalProps(() => ({
            component: 'defaultModalSuccessInMassSelectAll',
            imageClass: 'vbz-icon-corporates-club-beach-chair',
            isOpen: true,
            onClick: () => handleEditSuccesModalCTAClick(),
            secondClick: () => handleEditSuccesModalCTAClick(),
          }));
        } else {
          setDefaultModalProps(() => ({
            component: 'defaultModalSuccessInMass',
            imageClass: 'vbz-icon-corporates-club-beach-chair',
            isOpen: true,
            onClick: () => handleEditSuccesModalCTAClick(),
            secondClick: () => handleEditSuccesModalCTAClick(),
          }));
          setSelectedContractedPlan([]);
          setSelectedAvailablePlan([]);
        }
      }
    } else {
      setDefaultModalProps(() => ({
        ...defaultModalPropsDefaults,
        isOpen: true,
        onClick: () => setDefaultModalProps((prevState) => ({ ...prevState, isOpen: false })),
        secondClick: () => setDefaultModalProps((prevState) => ({ ...prevState, isOpen: false })),
      }));
    }
  };

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value);
  };

  const handleSwitch = (event: SyntheticEvent) => {
    if (event.target.checked) {
      addMember(memberFiltered as any);
      setAllSelected(true);
      setSelectAllSwicthChecked(true);
    } else {
      setAllSelected(false);
      clearMembers();
      setSelectAllSwicthChecked(false);
    }
  };

  const removeCheckedPlansEngaged = (): void => {
    setAllStatesCheckEngaged({
      ...allStatesCheckEngaged,
      '1000': false,
      '2000': false,
      '5000': false,
      '7000': false,
      '10000': false,
      '20000': false,
    });
    setSelectedContractedPlan([]);
  };

  const removeCheckedAvailablePlansEngaged = (): void => {
    setAllStatesAvailableCheckEngaged({
      ...allStatesAvailableCheckEngaged,
      '0': false,
      '1000': false,
      '2000': false,
      '5000': false,
      '7000': false,
      '10000': false,
      '20000': false,
    });
    setSelectedAvailablePlan([]);
  };

  const removeStartDateFilter = () => {
    setSelectedStartDate(null);
    setStartInclusionDate(null);
  };

  const removeEndDateFilter = () => {
    setSelectedEndDate(null);
    setEndInclusionDate(null);
  };

  const removeDateFilter = () => {
    removeStartDateFilter();
    removeEndDateFilter();
  };

  const removeAllFilters = () => {
    removeCheckedPlansEngaged();
    removeCheckedAvailablePlansEngaged();
    removeDateFilter();
    setLoading(true);
  };
  const verifyPressFilterButton = (): boolean => {
    if (filterButtonPressed) {
      return true;
    }
    return false;
  };

  useEffect(() => {
    Number.isNaN(Number(debouncedValue[0])) ? setSearch(debouncedValue) : setSearch(formatSearch(debouncedValue));
  }, [debouncedValue]);

  useEffect(() => {
    const localStorageBlockerTimer = localStorage.getItem('block-timer');
    if (localStorageBlockerTimer) {
      setEditionBlocked(true);
      setTimerWithSavedTime(Number(localStorageBlockerTimer), setEditionBlocked);
    }
  }, []);

  return (
    <>
      <div className="table-header-container">
        <div className="search-input">
          <VbzInputText placeholder="Pesquisar..." icon={<SearchIcon />} onChange={(e) => handleChange(e)} />
        </div>
        <div className="select-all-wrapper">
          <Switch
            onChange={handleSwitch}
            color="warning"
            inputProps={{ 'aria-label': 'controlled' }}
            checked={selectAllSwicthChecked}
          />

          <span className="select-all-wrapper-text">Selecionar todos</span>
          <div className="info">
            <svg
              className="info-icon"
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8.16797 4.83293H9.83463V6.49959H8.16797V4.83293ZM8.16797 8.16626H9.83463V13.1663H8.16797V8.16626ZM9.0013 0.66626C4.4013 0.66626 0.667969 4.39959 0.667969 8.99959C0.667969 13.5996 4.4013 17.3329 9.0013 17.3329C13.6013 17.3329 17.3346 13.5996 17.3346 8.99959C17.3346 4.39959 13.6013 0.66626 9.0013 0.66626ZM9.0013 15.6663C5.3263 15.6663 2.33464 12.6746 2.33464 8.99959C2.33464 5.32459 5.3263 2.33293 9.0013 2.33293C12.6763 2.33293 15.668 5.32459 15.668 8.99959C15.668 12.6746 12.6763 15.6663 9.0013 15.6663Z"
                fill="black"
              />
            </svg>
            <div className="tooltip-wrapper">
              <div className="message-tooltip"></div>
              <span className="-information-message">
                Edite todos os benefícios disponíveis para sua equipe de uma única vez.{' '}
              </span>
            </div>
          </div>
        </div>
        <div
          className={
            editionBlocked ? 'edition-blocked-banner-wrapper' : 'hide-edition-blocker edition-blocked-banner-wrapper'
          }
        >
          <div className="edition-blocked-banner">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M14 5H10V6.33333H14V5ZM11.3333 13.6667H12.6667V9.66667H11.3333V13.6667ZM16.6867 9.26L17.6333 8.31333C17.3467 7.97333 17.0333 7.65333 16.6933 7.37333L15.7467 8.32C14.7133 7.49333 13.4133 7 12 7C8.68667 7 6 9.68667 6 13C6 16.3133 8.68 19 12 19C15.32 19 18 16.3133 18 13C18 11.5867 17.5067 10.2867 16.6867 9.26ZM12 17.6667C9.42 17.6667 7.33333 15.58 7.33333 13C7.33333 10.42 9.42 8.33333 12 8.33333C14.58 8.33333 16.6667 10.42 16.6667 13C16.6667 15.58 14.58 17.6667 12 17.6667Z"
                fill="#FC2C5E"
              />
            </svg>
          </div>
          <span className="edition-blocked-banner-text">Aguarde 30 min para fazer uma nova edição</span>
        </div>
        {!isMobile && verifyPressFilterButton() ? (
          <div className="tags-container">
            {(selectedStartDate ||
              selectedEndDate ||
              plansEngagedChecked.length > 0 ||
              plansEngagedAvailableChecked.length > 0) && (
              <TagFilter onClick={removeAllFilters} label="Limpar filtros x" />
            )}
          </div>
        ) : null}
        <Button
          className={
            checkSelectedPlanInModal()
              ? 'filter-button filter-button-pressed club-filter-btn'
              : 'filter-button club-filter-btn'
          }
          onClick={() => setOpenFilterModal(true)}
          icon={<FilterIcon disabled={corporateClubList.length === 0 || corporateClubList === undefined} />}
          id="filter-btn"
          disabled={corporateClubList.length === 0}
        >
          <span data-testid="filter-button-testid">
            {plansEngagedCheckedNumber > 0 || plansAvailableEngagedCheckedNumber > 0
              ? `Filtros (${plansEngagedCheckedNumber + plansAvailableEngagedCheckedNumber})`
              : t('filter')}
          </span>
        </Button>
        <button
          className={
            allSelected || selectedMembers.length == 0
              ? 'exclud-btn hide-group-button-table-header'
              : 'exclud-btn group-button-table-header-button'
          }
          data-testid="remove-btn-test-id"
          onClick={() => setOpenRemovePlanModal(true)}
          type="button"
        >
          <div className="vbz-icon-corporates-club-trash" />
          <span className="ml-3">{t('btn_delete')}</span>
        </button>

        <button
          type="button"
          className={
            selectedMembers.length == 0
              ? 'edit-btn hide-group-button-table-header'
              : 'edit-btn group-button-table-header-button'
          }
          data-testid="edit-button-testid"
          onClick={handleEditProfile}
          disabled={editionBlocked}
        >
          <div className="vbz-icon-corporates-club-edit" />
          <span className="ml-3">{t('btn_edit')}</span>
        </button>
        {openFilterModal && <ResponseModal isOpen={openFilterModal} toggleModal={onToggleModal} />}
        <ModalDefault {...defaultModalProps} />
        <ModalAddingBeneficiaries
          isBeneficiariesButton={openModalBeneficiaries}
          isAddBenefitButton={false}
          closeModalBeneficiaries={closeModalBeneficiaries}
          isEditButtonProfile={false}
          addBeneficiaryHandler={editAllBeneficiaryHandler}
          profile={fakeProfile as any}
        />
        {openRemovePlanModal && (
          <ModalRemovePlan
            onClick={removeSelectedBeneficiariesPlansHandler}
            isOpen={openRemovePlanModal}
            toggleModal={onToggleRemovePlanModal}
            component="modalRemoveBenefitMass"
          />
        )}
      </div>
    </>
  );
};
